module.exports = __webpack_public_path__ + "img/fuangkuanshibai.1c60f11d.png";